import { Injectable } from '@angular/core';
import {
    MeetingTypeList, MeetingType, SectionHeader,
    MeetingList, MeetingTypeAgendaTemplate, WorkFlowDetails, Agenda, AgendaItemList, SettingMeetingTypeList
} from './../models/meeting-type-model.model';


@Injectable({
    providedIn: 'root'
})

export class MeetingTypeMapping {
    constructor() {

    }

    public getMeetingTypeList(responseData: any): Array<MeetingTypeList> {
        const meetingTypeList: Array<MeetingTypeList> = [];
        responseData.meetingType.forEach((data: any) => {
            const meetingType = {
                title: data.title,
                id: data.id,
                colorHexCode: data.colorHexCode,
                selected: true,
                meetings: []
            };
            meetingTypeList.push(meetingType);
        });
        return meetingTypeList;

    }



    public getMeetingTypeById(responseData: any): MeetingType {
        let meetingTypeModel: MeetingType = new MeetingType();
        meetingTypeModel = {
            title: responseData['title'],
            location: responseData['location'],
            description: responseData['description'],
            agendaTemplate: responseData['agendaTemplate'],
            colorHexCode: responseData['colorHexCode'],
            agendaItems: this.getWorkflowTypeProcess(responseData['agendaItems']),
            agenda: this.getWorkflowTypeProcess(responseData['agenda']),
            meetingMinutes: this.getWorkflowTypeProcess(responseData['meetingMinutes']),
            sectionHeader: [],
            attendees: responseData['attendees'],
            meetingTypeId: responseData['meetingTypeId']
        };
        meetingTypeModel.sectionHeader = this.getSectionHeaderMapping(responseData['sectionHeader']);
        return meetingTypeModel;

    }
    public getWorkflowTypeProcess(responseData: any) {
        const workflowProcess: WorkFlowDetails = {
            approvers: responseData.approvers,
            maxApprovers: responseData.maxApprovers,
            minApprovers: responseData.minApprovers,
            type: responseData.type,
            isFormValid: true,
            oldApprovers: responseData.responseData
        };
        return workflowProcess;
    }
    public getSectionHeaderMapping(response: any): Array<SectionHeader> {
        const sectionHeaderList: Array<SectionHeader> = [];
        response.forEach((sectionHeader: any) => {
            const tempSH: SectionHeader = {
                id: sectionHeader.id,
                title: sectionHeader.title,
                order: sectionHeader.order,
                isDraggable: true,
                isEditable: false
            };
            sectionHeaderList.push(tempSH);
        });
        return sectionHeaderList;
    }

    public getMeetingsByMeetingType(response: any): MeetingTypeList {
        const meeting = new MeetingTypeList();
        if (response.length > 0) {
            meeting.title = response[0].title;
            meeting.id = response[0].meetingTypeId;
            meeting.meetings = this.getMeetingsList(response[0].meetings); // response[0].meetings;
        }
        return meeting;
    }

    public getSettingByMeetingType(response: any): SettingMeetingTypeList {
        const meeting = new SettingMeetingTypeList();
        if (response.length > 0) {
            meeting.title = response[0].title;
            meeting.id = response[0].meetingTypeId;
            meeting.meetings = this.getMeetingsList(response[0].meetings); // response[0].meetings;
            meeting.agendaItems = this.getAgendaItemList(response[0].agendaItems);
            meeting.meetingAgendas = this.getAgendaList(response[0].meetingAgendas);
        }
        return meeting;
    }
    private getMeetingsList(response: any): Array<MeetingList> {
        const meetingList: Array<MeetingList> = [];
        response.forEach((data: any) => {
            const meetingType = {
                title: data.title,
                id: data.id,
                recurringId: data.recurringId,
                startDate: data.startDate

            };
            meetingList.push(meetingType);
        });
        return meetingList;
    }
    public getAgendaList(response: any): Array<Agenda> {
        const agendaList: Array<Agenda> = [];
        response.forEach((data: any) => {
            const agenda = {
                title: data.title,
                id: data.id,
            };
            agendaList.push(agenda);
        });
        return agendaList;
    }
    public getAgendaItemList(response: any): Array<AgendaItemList> {
        const agendaItemList: Array<AgendaItemList> = [];
        response.forEach((data: any) => {
            const agendaItem = {
                title: data.title,
                id: data.id,

            };
            agendaItemList.push(agendaItem);
        });
        return agendaItemList;
    }

    public getMeetingTypesList(response: any): Array<MeetingTypeAgendaTemplate> {
        const meetingTypeList: Array<MeetingTypeAgendaTemplate> = [];
        response.forEach((data: any) => {
            const meetingType = {
                meetingTypeId: data.meetingTypeId,
                meetingTypeTitle: data.meetingTypeTitle,
            };
            meetingTypeList.push(meetingType);
        });
        return meetingTypeList;
    }


}
